import React from 'react';
import { User } from '../services/types';
import './RoleBadge.css';

interface RoleBadgeProps {
    user: User;
}

const RoleBadge: React.FC<RoleBadgeProps> = ({ user }) => {
    if (!user.roles || user.roles.length === 0) {
        return null;
    }

    // Determine the highest priority role to display
    const getDisplayRole = (roles: string[]): string | null => {
        const rolePriority = ['administrator', 'birds_modo', 'subscriber'];
        
        for (const role of rolePriority) {
            if (roles.includes(role)) {
                return role;
            }
        }
        return null;
    };

    const displayRole = getDisplayRole(user.roles);
    
    if (!displayRole) {
        return null;
    }

    const getRoleLabel = (role: string): string => {
        switch (role) {
            case 'administrator':
                return 'Admin';
            case 'birds_modo':
                return 'Modérateur';
            case 'subscriber':
                return 'Membre';
            default:
                return role;
        }
    };

    return (
        <span className={`RoleBadge RoleBadge--${displayRole}`}>
            {getRoleLabel(displayRole)}
        </span>
    );
};

export default RoleBadge;
